import type { PublicSlotKey } from '@/apilib';
import type { ListClassificationApi } from './listClassificationApi';

export const ListClassificationApiKey: PublicSlotKey<ListClassificationApi> = {
  name: 'ListClassificationApi',
  public: true,
};
